export default "__VITE_ASSET__77cd6ea8__"